import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {User} from '../../../../../models/user';
import {Document} from '../../../../../models/document';
import {BusinessDataService} from '../../../../../data-repositories/business-data.service';
import {DocumentsService} from '../../../../../services/documents.service';
import {AdditionalDocument} from '../../../../../models/additional-document';
import {Subscription} from 'rxjs';
import {ValidationInfoService} from '../../../../../repositories/validation-info.service';
import {MatDialog} from '@angular/material/dialog';
import {DocumentsPromptComponent} from '../../components/documents/documents-prompt/documents-prompt.component';
import {WorkspaceService} from '../../../workspace.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-documents-single',
  templateUrl: './documents-single.component.html',
  styleUrls: ['./documents-single.component.scss']
})
export class DocumentsSingleComponent implements OnInit, OnDestroy {
  user: User;
  identityDocuments: Document[];
  addressDocuments: Document[];
  submitted: boolean;
  private _identityDocument: Document;
  private _addressDocument: Document;
  private _subscription$: Subscription;
  private _userSubscription$: Subscription;
  private _continue = false;

  constructor(
    private service: BusinessDataService,
    private validationService: ValidationInfoService,
    private dialog: MatDialog,
    private workspaceService: WorkspaceService,
    private documentsService: DocumentsService,
    private translateService: TranslateService,
    public toastr: ToastrService
  ) {

    this._userSubscription$ = this.service.GetUser().subscribe(s => {
      this.user = s.model;

      this.identityDocuments = this.documentsService.getIdentityDocuments(this.user);
      this.addressDocuments = this.documentsService.getAddressDocuments(this.user);
    });

    this.submitted = false;
  }

  ngOnInit() {
    this._subscription$ = this.validationService.onUserUpdate.subscribe((payload: { isNavigate: true }) => {
      this.submitted = true;
      let validDocuments = true;

      if (this._identityDocument.requiredBack && !this.user.proofIdentetyBackDocument) {
        validDocuments = false;
      }

      if (this._identityDocument.requiredFront && !this.user.proofIdentetyDocument) {
        validDocuments = false;
      }

      if (this._addressDocument.requiredFront && !this.user.proofAddressDocument) {
        validDocuments = false;
      }

      if (this._addressDocument.requiredBack && !this.user.proofAddressBackDocument) {
        validDocuments = false;
      }

      if (this._identityDocument.requiredDate && this.user.proofIdentetyDocument && !this.user.proofIdentetyDocument.expireDate) {
        this.validationService.validate(false, 'DocumentsFirstHolderComponent');
        this.toastr.error(this.translateService.instant('Documents.ExpireDateRequiredOrInvalid'));
        return;
      }

      if (this._addressDocument.requiredDate && this.user.proofAddressDocument && !this.user.proofAddressDocument.expireDate) {
        this.validationService.validate(false, 'DocumentsFirstHolderComponent');
        this.toastr.error(this.translateService.instant('Documents.ExpireDateRequiredOrInvalid'));
        return;
      }

      if (!payload.isNavigate && !validDocuments && !this._continue) {
        this.validationService.validate(false, 'DocumentsFirstHolderComponent');
        const dialogRef = this.dialog.open(DocumentsPromptComponent, {
          width: '90vw',
          maxWidth: '450px',
          panelClass: ['dialog-container', 'info-panel', 'p-0'],
          backdropClass: 'info-backdrop',
          disableClose: true
        });

        dialogRef.afterClosed().subscribe(d => {
          this._continue = d;
          if (this._continue) {
            this.workspaceService.next();
          }
        });
      } else {
        this._continue = true;
        this.validationService.validate(true, 'DocumentsFirstHolderComponent');
      }
    });
  }

  ngOnDestroy(): void {
    this._subscription$.unsubscribe();
    this._userSubscription$?.unsubscribe();
  }

  public updateUser(): void {
    this.service.updateUserWithoutValidation(this.user, () => {
    });
  }

  uploadDocument(document: AdditionalDocument): Promise<AdditionalDocument> {
    return new Promise<AdditionalDocument>((resolve) => {
      this.service.uploadDocument(document, (d) => {
        resolve(d);
      }, (e) => {
        this.toastr.error(e);
        resolve(null);
      });
    });
  }

  updateDocument(document: AdditionalDocument): Promise<AdditionalDocument> {
    return new Promise<AdditionalDocument>((resolve) => {
      this.service.updateDocument(document, (d) => {
        resolve(d);
      }, (e) => {
        this.toastr.error(e);
        resolve(null);
      });
    });
  }

  removeDocument(document: AdditionalDocument): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.service.removeDocument(document.id, (d) => {
        resolve(true);
      }, (e) => {
        this.toastr.error(e);
        resolve(false);
      });
    });
  }

  onIdentityDocumentSelect(document: Document) {
    this._identityDocument = document;
  }

  onAddressDocumentSelect(document: Document) {
    this._addressDocument = document;
  }
}
